import * as z from 'zod';
import type {
  CheckboxProperties as CheckboxPropsType,
  CheckboxOption,
  CheckboxOrientation,
} from './form.types';
import { CHECKBOX_DEFAULTS, MIN_OPTIONS } from '../lib/checkbox-constants';
import { FORM_FIELD_CHARACTER_LIMITS } from '../lib/form-field-character-limits';

export interface CheckboxFormValues {
  name: string;
  placeholder?: string;
  label?: string;
  labelPosition?: 'top' | 'left';
  orientation?: CheckboxOrientation;
  required?: boolean;
  multipleSelection?: boolean;
  options: CheckboxOption[];
}

export const checkboxValidationSchema = z.object({
  name: z
    .string()
    .min(1, 'O nome é obrigatório')
    .max(FORM_FIELD_CHARACTER_LIMITS.FIELD_ID),
  placeholder: z
    .string()
    .max(FORM_FIELD_CHARACTER_LIMITS.AUXILIARY_TEXT)
    .optional(),
  label: z
    .string()
    .max(FORM_FIELD_CHARACTER_LIMITS.LABEL)
    .optional(),
  labelPosition: z.enum(['top', 'left']).optional(),
  orientation: z.enum(['vertical', 'horizontal']).optional(),
  required: z.boolean().optional(),
  multipleSelection: z.boolean().optional(),
  options: z
    .array(
      z.object({
        id: z.string(),
        text: z.string().min(1, 'Texto da alternativa é obrigatório'),
      })
    )
    .min(MIN_OPTIONS, `Mínimo de ${MIN_OPTIONS} alternativa`),
});

export function extractCheckboxInitialValues(
  properties: CheckboxPropsType | undefined
): CheckboxFormValues {
  return {
    name: properties?.name ?? '',
    placeholder: properties?.placeholder ?? '',
    label: properties?.label ?? '',
    labelPosition: properties?.labelPosition ?? CHECKBOX_DEFAULTS.LABEL_POSITION,
    orientation: properties?.orientation ?? CHECKBOX_DEFAULTS.ORIENTATION,
    required: properties?.required ?? false,
    multipleSelection: properties?.multipleSelection ?? false,
    options: properties?.options ? [...properties.options] : [...CHECKBOX_DEFAULTS.OPTIONS],
  };
}

export function mapCheckboxValuesToProperties(
  formValues: CheckboxFormValues,
  currentProperties: CheckboxPropsType
) {
  const rest = { ...formValues };
  delete (rest as Partial<CheckboxFormValues>).options;
  return {
    properties: {
      ...currentProperties,
      ...rest,
      name: formValues.name || currentProperties.name,
    },
  };
}
